export { default } from './GatsbyImage';
